<template>

    <div class="c-setting__action o-switch switch-right no-select">

        <input v-if="!isDisabled" ref="checkbox" :checked="state" class="c-switch__input o-switch__input no-select" type="checkbox" @change="update" @click="emitClick">

        <div :class="{ 'o-switch__background__disabled': isDisabled }" class="c-switch__background o-switch__background no-select" @click="emitClick">

            <div class="c-switch__knob o-switch__knob no-select"></div>

        </div>
    </div>

</template>

<script>

export default {

    name: 'checkbox-circle',

    props: {

        state: {
            type: Boolean,
            default: false
        },

        disabled: {
            type: Boolean,
            default: false
        }
    },

    computed: {

        isDisabled() {

            return this.disabled

        }
    },

    methods: {

        update() {

            if (!this.isDisabled) {
                this.$emit('change', this.$refs.checkbox.checked)
            }
        },

        check() {

            this.$refs.checkbox.checked = true

        },

        uncheck() {

            this.$refs.checkbox.checked = false

        },

        emitClick() {
            this.$emit('click')
        }
    }

}

</script>

<style lang="scss" scoped>


.no-select {
    -webkit-tap-highlight-color: transparent;
}

.o-switch {
    position: relative;
    width: 51px;
    height: 31px;

    &__input {
        display: inline-block;
        position: absolute;
        /*top: 0;*/
        left: 0;
        opacity: 0;
        z-index: 2;
        cursor: pointer;
        outline: none;
        width: 100%;
        height: 100%;

        &:checked ~ .o-switch__background {
            &:before {
                background-color: #4cd964;
            }

            .o-switch__knob {
                transform: translateX(1.35em);
                background-color: white;
                box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.1), 0 1px 1px 0 rgba(0, 0, 0, 0.16), 0 3px 8px 0 rgba(0, 0, 0, 0.15);
                border: solid 0.5px rgba(0, 0, 0, 0.04);
            }
        }
    }

    &__background {
        user-select: none;
        display: block;
        position: relative;
        cursor: pointer;
        border-radius: 7px;
        background-color: transparent;
        width: 100%;
        height: 100%;

        &:before {
            display: block;
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            border-radius: 1000px;
            content: "";
            width: 51px;
            height: 31px;
            background-color: #E9E9E9;
        }

        &__disabled {
            opacity: 0.48;
            cursor: not-allowed;
        }
    }

    &__knob {
        display: block;
        position: absolute;
        top: 0.09em;
        left: 0.05em;
        border-radius: 100%;
        background: white;
        width: 28px;
        height: 28px;
        background-color: white;
        box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.1), 0 1px 1px 0 rgba(0, 0, 0, 0.16), 0 3px 8px 0 rgba(0, 0, 0, 0.15);
        border: solid 0.5px rgba(0, 0, 0, 0.04);
    }
}

</style>
